<template>
    <div id="status-calendar">
        <button class="button is-primary is-small" v-if="planned" @click="show=!show">{{show?'Hide Planned':'Show Planned'}}</button>
        <div class="separator-planned" v-if="planned"></div>
        <div v-if="show">
            <span id="progress-bar" v-if="steps && steps.length>0 && !planned">
                <span id="full" :style="{'flex-grow': filled}"/>
                <span id="empty" :style="{'flex-grow': empty}"/>
            </span>
            <div class="wrapper">
                <div :class="'step ' + step.class" v-for="(step, index) in steps" :key="index" :style="planned ? 'padding-bottom: 1em; min-height:100px':''"
                :title="step.tooltip">
                    <span class="flag-wrapper" v-if="step.flag">
                      <img :src="`https://hatscripts.github.io/circle-flags/flags/${step.flag}.svg`" width="36">
                      <span class="ico-wrapper">
                        <icon icoClass="flag-event-ico" :selected='step.img'/>
                      </span>
                    </span>
                    <span class="ico-wrapper" v-else>
                      <icon icoClass="event-ico" :selected='step.img'/>
                    </span>
                    <div class="bold-title">{{step.locode}}</div>
                    <div class="mini-title">{{step.name}}</div>
                    <div v-if="!step.date" class="bold-title dates">
                      <div class="date-group">
                        <span class="date-wrapper arrival">
                            <div class="date-title">ARRIVAL</div>
                            <div class="date" v-if="step.arrival" :style="step.arrival.real? 'color: black':' color: grey'">{{step.arrival.date | toString}}</div>
                        </span>
                        <span class="date-wrapper discharge">
                            <div class="date-title" :style="step.discharge? '':'visibility:hidden'">DISCHARGE</div>
                            <div class="date" v-if="step.discharge" :style="step.discharge.real? 'color: black':' color: grey'">{{step.discharge.date | toString}}</div>
                        </span>
                      </div>
                      <div class="date-group">
                        <span class="date-wrapper load">
                            <div class="date-title" :style="step.load? '':'visibility:hidden'">LOAD</div>
                            <div class="date" v-if="step.load" :style="step.load.real? 'color: black':' color: grey'">{{step.load.date | toString}}</div>
                        </span>
                        <span class="date-wrapper departure">
                            <div class="date-title">DEPARTURE</div>
                            <div class="date" v-if="step.departure" :style="step.departure.real? 'color: black':' color: grey'">{{step.departure.date | toString}}</div>
                        </span>
                      </div>
                    </div>
                    <div class="bold-title dates" v-else>
                        <span class="date-wrapper">
                            <div class="date-title">{{'DATE'}}</div>
                            <div class="date" v-if="step.date" :style="step.date.real? 'color: black':' color: grey'">{{step.date.date | toString}}</div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icon from './../svg/events'
import moment from 'moment'

const fields = {
  n: '_loc',
  a: [
    'arrival_planned_initial',
    'arrival_planned_last',
    'arrival_actual',
    'arrival_detected'
  ],
  d: [
    'departure_planned_initial',
    'departure_planned_last',
    'departure_actual',
    'departure_detected'
  ],
  other: ['planned_initial', 'planned_last', 'actual']
}
const headers = [
  {n: 'empty_pickup', f: 'empty_pickup_', name: 'Empty to Shipper'},
  {n: 'origin', f: 'origin_pickup_', name: 'Origin'},
  {n: 'pol', a: 'pol_', d: 'pol_vsl', load: 'pol_loaded_', discharge: 'pol_discharge_', name: 'POL'},
  {n: 'tsp1', a: 'tsp1_vsl', d: 'tsp1_vsl', load: 'tsp1_loaded_', discharge: 'tsp1_discharge_', name: 'Transhipment 1'},
  {n: 'tsp2', a: 'tsp2_vsl', d: 'tsp2_vsl', load: 'tsp2_loaded_', discharge: 'tsp2_discharge_', name: 'Transhipment 2'},
  {n: 'tsp3', a: 'tsp3_vsl', d: 'tsp3_vsl', load: 'tsp3_loaded_', discharge: 'tsp3_discharge_', name: 'Transhipment 3'},
  {n: 'tsp4', a: 'tsp4_vsl', d: 'tsp4_vsl', load: 'tsp4_loaded_', discharge: 'tsp4_discharge_', name: 'Transhipment 4'},
  {n: 'pod', a: 'pod_vsl', d: 'pod_', load: 'pod_loaded_', discharge: 'pod_discharge_', name: 'POD'},
  {n: 'lif', f: 'lif_', a: 'lif_', d: 'lif_', name: 'Last Inland Facility'},
  {n: 'dlv', f: 'dlv_delivery_', name: 'Delivery'},
  {n: 'empty_return', f: 'empty_return_', name: 'Empty to Depot'}
]

export default {
  name: 'status-calendar',
  props: ['shipment', 'planned'],
  mounted () {
    if (!this.planned) {
      this.show = true
    }
  },
  components: {icon},
  data () {
    return {
      show: false
    }
  },
  computed: {
    filled () {
      var amount = 0
      this.steps.forEach((step, index) => {
        if ((step.arrival && step.arrival.real) || (step.discharge && step.discharge.real)) { amount = (index + 1) * 2 - 1 }
        if ((step.departure && step.departure.real) || (step.load && step.load.real) || (step.date && step.date.real)) { amount = (index + 1) * 2 }
      })
      return amount
    },
    empty () {
      if (this.steps) {
        return this.steps.length * 2 - this.filled
      }
      return 0
    },
    steps () {
      var steps = []
      if (this.shipment.id) {
        headers.forEach(header => {
          var step = {}
          step.name = header.name
          if (header.n === 'discharge' || header.n === 'loaded' || header.n === 'dlv' || header.n === 'origin' || header.n === 'empty_pickup' || header.n === 'empty_return') {
            step.img = (header.n === 'dlv' || header.n === 'origin') ? 'location' : header.n
            step.class = header.n
            if (this.shipment[header.n + fields.n]) {
              step.flag = (this.shipment[header.n + fields.n].country_iso2) ? this.shipment[header.n + fields.n].country_iso2.toLowerCase() : 'xx'
              step.locode = this.shipment[header.n + fields.n].locode
            } else if (header.n === 'empty_pickup') {
              step.locode = 'EMPTY TO SHIPPER'
              step.name = ''
            } else if (header.n === 'origin') {
              step.locode = 'PICKUP AT SHIPPER'
              step.name = ''
            } else if (header.n === 'empty_return') {
              step.locode = 'EMPTY TO DEPOT'
              step.name = ''
            } else {
              step.locode = header.n.toUpperCase()
              step.name = ''
            }
            if (this.planned) {
              if (this.shipment[header.f + fields.other[0]]) {
                step.date = {date: new Date(this.shipment[header.f + fields.other[0]]), real: fields.other[0].indexOf('planned') < 0}
                steps.push(step)
              }
            } else {
              fields.other.forEach((field) => {
                if (this.shipment[header.f + field]) {
                  step.date = {date: new Date(this.shipment[header.f + field]), real: field.indexOf('planned') < 0}
                }
              })
              if (step.date) steps.push(step)
            }
          } else if (this.shipment[header.n + fields.n].locode) {
            step.locode = this.shipment[header.n + fields.n].locode
            step.flag = (this.shipment[header.n + fields.n].country_iso2) ? this.shipment[header.n + fields.n].country_iso2.toLowerCase() : 'xx'
            if (this.shipment[header.n + '_vslarrival_prediction']) {
              var predicted = this.shipment[header.n + '_vslarrival_prediction'].predicted
              if (predicted) {
                predicted = moment(predicted).format('YYYY-MM-DD')
              }
              var upper = this.shipment[header.n + '_vslarrival_prediction'].predicted_upper
              if (upper) {
                upper = moment(upper).format('YYYY-MM-DD')
              }
              var lower = this.shipment[header.n + '_vslarrival_prediction'].predicted_lower
              if (lower) {
                lower = moment(lower).format('YYYY-MM-DD')
              }
              step.tooltip = ''
              if (lower & upper) {
                step.tooltip += `Arrival between ${lower} and ${upper}.`
              }
              if (!step.tooltip) {
                if (lower) {
                  step.tooltip += `Arrival after ${lower}`
                }
                if (upper) {
                  step.tooltip += `Arrival before ${upper}`
                }
              }
              if (predicted) {
                step.tooltip += `Most likely on ${predicted}.`
              }
              step.class += ' help-cursor'
            }
            if (this.planned) {
              var arr
              if (this.shipment[header.a + fields.a[0]]) {
                arr = new Date(this.shipment[header.a + fields.a[0]])
              } else {
                arr = ''
              }
              var dep
              if (this.shipment[header.d + fields.d[0]]) {
                dep = new Date(this.shipment[header.d + fields.d[0]])
              } else {
                dep = ''
              }
              var load
              if (this.shipment[header.load + fields.other[0]]) {
                load = new Date(this.shipment[header.load + fields.other[0]])
              } else {
                load = ''
              }
              var discharge
              if (this.shipment[header.discharge + fields.other[0]]) {
                discharge = new Date(this.shipment[header.discharge + fields.other[0]])
              } else {
                discharge = ''
              }
              step.arrival = {date: arr, real: fields.a[0].indexOf('planned') < 0}
              step.departure = {date: dep, real: fields.d[0].indexOf('planned') < 0}
              step.load = {date: load, real: fields.other[0].indexOf('planned') < 0}
              step.discharge = {date: discharge, real: fields.other[0].indexOf('planned') < 0}
              if (!step.arrival.date) { step.arrival = undefined }
              if (!step.departure.date) { step.departure = undefined }
              if (!step.load.date) { step.load = undefined }
              if (!step.discharge.date) { step.discharge = undefined }
            } else {
              fields.a.forEach((field) => {
                if (this.shipment[header.a + field]) {
                  step.arrival = {date: new Date(this.shipment[header.a + field]), real: field.indexOf('planned') < 0}
                }
              })
              fields.d.forEach((field) => {
                if (this.shipment[header.d + field]) {
                  step.departure = {date: new Date(this.shipment[header.d + field]), real: field.indexOf('planned') < 0}
                }
              })
              fields.other.forEach((field) => {
                if (this.shipment[header.load + field]) {
                  step.load = {date: new Date(this.shipment[header.load + field]), real: field.indexOf('planned') < 0}
                }
                if (this.shipment[header.discharge + field]) {
                  step.discharge = {date: new Date(this.shipment[header.discharge + field]), real: field.indexOf('planned') < 0}
                }
              })
            }
            step.img = (header.n === 'lif') ? 'location' : 'anchor'
            steps.push(step)
          }
        })
      }
      return steps
    }
  },
  filters: {
    toString: function (value) {
      if (value instanceof Date && !isNaN(value.valueOf())) {
        let dateString = moment(value).format('YYYY-MM-DD')
        return dateString
      }
      if (typeof (value) === 'object' && value) {
        return value.__str__
      }
      if (value) {
        return value.toString()
      }
      return ''
    }
  },
  methods: {
  }
}
</script>
<style lang="scss">
.separator-planned {
    display: inline-block;
    height: 1px;
    width: 100%;
    padding: 0;
    margin: 0;
    vertical-align: top;
}
.flag-wrapper {
  display: inline-block;
  margin-top: -.4em;
  img {
    filter: contrast(0.65) brightness(1.25);
  }
  .ico-wrapper{
    line-height: 1em;
    margin-left: -1em;
    z-index: 200;
    position: relative;
    box-shadow: -.1em .1em .2em rgba($color: #000000, $alpha: .5);
  }
}
.dates {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: stretch;
}
.date-group{
  flex: 1;
  display: flex;
  flex-direction: column;
}
.date-wrapper {
  margin: .3em;
  flex:1;
}
.date-title {
    font-size: .7em;
    font-family: MuseoSans-900;
    color: gray;
    white-space: nowrap;
}
.date {
    font-size: .85em;
    margin-top: .5em;
    white-space: nowrap;
}
#status-calendar{
    position: relative;
}
#full {
    background: rgb(48, 177, 65);
}
#empty {
    background: white;
}
#progress-bar {
    border: 1px solid lightgray;
    border-radius: 6px;
    height: 32px;
    width: calc(100% - 4em);
    display: flex;
    position: absolute;
    box-sizing: border-box;
    bottom: 0;
    margin: 2em;
    overflow: hidden;
}
.wrapper {
    display: flex;
}
.step{
    margin: 0 .5em 1.5em .5em;
    background: white;
    border: 1px solid lightgray;
    border-radius: 10px;
    min-height: 150px;
    width: 150px;
    flex-grow: 1;
    padding: 1em .3em;
    text-align: center;
    padding-bottom: 3.5em;
}
.loaded .ico-wrapper, .discharge .ico-wrapper {
    background: #e21b7a;
}
.loaded, .discharge, .empty_pickup, .origin, .dlv, .empty_return, .lif {
  // ducks up the progress bar flex: 1;
}
 .ico-wrapper, .empty_pickup .ico-wrapper, .ico-wrapper, .empty_return .ico-wrapper, .lif .ico-wrapper {
    background: #39bc08;
}
.dlv  .ico-wrapper, .origin .ico-wrapper{
  background: #ff7525;
}
.ico-wrapper {
    background: rgb(28, 167, 209);
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
}

@media only screen and (max-width: 1000px) {
#progress-bar {
    flex-direction: column;
    height: calc(100% - 4em);
    width: 32px;
}
.wrapper {
    flex-direction: column;
}
.step{
    flex: 1;
    min-width: 75%;
    padding: 1em .3em;
    text-align: center;
    padding-left: 3.5em;
}
}
.help-cursor{
  cursor:help;
}
</style>



// WEBPACK FOOTER //
// src/components/StatusCalendar.vue